import React from 'react';
import InputMask from 'react-input-mask';
import { useFormikContext } from 'formik';
import { get, upperFirst } from 'lodash';

import Input from '../Input';
import { FormInputFieldProps } from '../types';

type Props = {
  mask?: string;
  requestParamName?: string;
  isRequired?: boolean;
  maskPlaceholder?: string;
  isOptRequired?: boolean;
  isRequiredAtStart?: boolean;
  isDisabledBtnDots?: boolean;
  noGrowth?: boolean;
};

const MaskInput: React.FC<Props & FormInputFieldProps> = React.memo(
  ({ onChange, mask = '38 (099) 999-99-99', maskPlaceholder = '_', disabled, ...props }) => {
    const formik = useFormikContext();
    const name = props.name.split('.')[0];
    const isTripCont = get(formik.values, `is${upperFirst(name)}PhoneNumberValid`);

    const handleChange = (e: any) => {
      if (isTripCont) formik.setFieldValue(`is${upperFirst(name)}PhoneNumberValid`, false);

      if (maskPlaceholder === '') {
        const val = e.target?.value?.replace(/\D+/g, '');
        return formik.setFieldValue(props.name, val);
      }

      // @ts-ignore
      onChange(e);
    };

    /*  const beforeMaskedValueChange = (newState: any, oldState: any, userInput: any) => {
      let { value, selection } = newState;
      let cursorPosition = selection ? selection.start : null;

      // keep minus if entered by user
      // @ts-ignore
      if (value.endsWith('-') && userInput !== '-' && !oldState.value.endsWith('-')) {
        if (cursorPosition === value.length) {
          // eslint-disable-next-line
          cursorPosition--;
          selection = { start: cursorPosition, end: cursorPosition };
        }
        value = value.slice(0, -1);
      }

      return {
        value,
        selection,
      };
    }; */

    const maskChar = maskPlaceholder === '' ? null : maskPlaceholder;

    return (
      <InputMask
        mask={mask}
        value={props.value} // @ts-ignore
        maskChar={maskChar}
        onChange={handleChange}
        maskPlaceholder={maskPlaceholder}
        disabled={disabled}
        onFocus={props.onFocus}
        /*   beforeMaskedValueChange={beforeMaskedValueChange}
        formatChars={{
          '9': '[0-9]',
          a: '[A-Za-z]',
          '*': '[A-Za-z0-9]',
          '#': '[A-fa-f0-9]',
        }} */
      >
        {/* eslint-disable-next-line @typescript-eslint/no-shadow */}
        {(maskPlaceholder: any, inputProps: any) => <Input {...inputProps} {...props} isMask disabled={disabled} />}
      </InputMask>
    );
  },
);

export default MaskInput;
